import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useContext } from "react";
import { AppContext } from "../context/AppContext";
const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
const url = apiEndPoint + "/SPLforLoB/?key=";
const Specialization = ({ formInputData, handleInputChange }) => {
  const [setLoaderActive] = useContext(AppContext);
  const [specialities, setSpeciality] = useState([]);
  const fetchSpeciality = async () => {
    if (formInputData.lob_id === "") {
      setSpeciality([]);
      return true;
    }
    try {
      setLoaderActive(true);
      const spl = await fetch(url + formInputData.lob_id).then((response) =>
        response.json()
      );
      if (spl.success) {
        setSpeciality(spl.response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoaderActive(false);
    }
  };
  useEffect(() => {
    fetchSpeciality();
  }, [formInputData.lob_id]);
  if (specialities.length === 0) {
    return <></>;
  }
  return (
    <fieldset>
      <legend>Business Specialization Details</legend>
      <Card className="mb-3">
        <Card.Header as="h5">Service Specilization List</Card.Header>
        <Card.Body>
          <Row sm={2} md={3} lg={4} xs={2}>
            {specialities.map((speciality) => {
              return (
                <Col
                  key={speciality.business_spl_id}
                  className="mb-3 d-flex justify-content-center"
                >
                  <input
                    type="checkbox"
                    value={speciality.business_spl_id}
                    checked={formInputData.specialities.includes(
                      speciality.business_spl_id.toString()
                    )}
                    onChange={handleInputChange}
                    name="speciality"
                    className="btn-check"
                    id={`spl_${speciality.business_spl_id}`}
                  />
                  <label
                    className="btn btn-outline-primary"
                    htmlFor={`spl_${speciality.business_spl_id}`}
                  >
                    {speciality.business_spl_name}
                  </label>
                </Col>
              );
            })}
          </Row>
        </Card.Body>
      </Card>
    </fieldset>
  );
};

export default Specialization;
